window.NodeList&&!NodeList.prototype.forEach&&(NodeList.prototype.forEach=function(o,t){t=t||window;for(var i=0;i<this.length;i++)o.call(t,this[i],i,this)});



//////////////////
// WEBPACK FOOTER
// ./node_modules/mdn-polyfills/NodeList.prototype.forEach.js
// module id = 588
// module chunks = 11